import { type CitationSource, type MeetingCitationSource } from '../models/Citation'
import { getIntegrationDisplayName, type IntegrationServiceId } from './integrations'

export const UNKNOWN_CITATION_SOURCE = 'Unknown'

export const isMeetingSource = (source: CitationSource): source is MeetingCitationSource => source.type === 'meeting'

export const citationSourceLabel = (source: CitationSource): string => {
  if (isMeetingSource(source)) {
    return 'Meeting'
  }
  if (source.type === 'external') {
    return source.name?.trim() || 'External data source'
  }
  return source.service_id ? getIntegrationDisplayName(source.service_id as IntegrationServiceId) : UNKNOWN_CITATION_SOURCE
}
